/* unplugin-vue-components disabled */import { render } from "./aboutLink.vue?vue&type=template&id=63646cd2&scoped=true"
import script from "./aboutLink.vue?vue&type=script&lang=js"
export * from "./aboutLink.vue?vue&type=script&lang=js"

import "./aboutLink.vue?vue&type=style&index=0&id=63646cd2&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户上电-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63646cd2"]])

export default __exports__